module.exports = __webpack_public_path__ + "media/images/common/app_appstore-c4b88bf0f8d72c5fd43831585d202e8b.png";